<template>
  <div class="animated fadeIn list-of-so">
    <b-card>
      <div slot="header">
        Revision on CLOSED Sales Order        
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()">Print</b-button>
          <b-button variant="primary mr-1" @click="approvalConfirm()"><i class="fa fa-paper-plane"></i> Approval</b-button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <b-button variant="primary mr-1" @click="togleFilter()">
            <i class="fa fa-filter"></i> Filter
          </b-button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" placeholder="sales order number"></b-form-input>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Doc. Reference</span></b-input-group-prepend>
            <b-form-input v-model="tblData.ExtrDocNo" placeholder="external  doc. no"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
            <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
            <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
            <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
            <b-form-input v-model="tblData.customer" ></b-form-input>
            <b-input-group-append>
              <b-btn variant="primary" @click="lkuKoranCustShow=true"> <i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Advertiser</span></b-input-group-prepend>
            <b-form-input v-model="tblData.Advertiser"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend><label>Sales AE</label></b-input-group-prepend>
            <b-form-input v-model="tblData.sales_search"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuSalesShow=true" variant="primary"><i class="fa fa-search"></i></b-btn>
            </b-input-group-append>
            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Description</span></b-input-group-prepend>
            <b-form-input v-model="tblData.uraian"></b-form-input>
          </b-input-group>
            <b-input-group>
                <b-input-group-prepend><label>Campaign</label></b-input-group-prepend>
                <b-form-input v-model="tblData.campaign" ></b-form-input>
                <b-input-group-append>
                  <b-btn variant="primary" @click="lkuSalesCamapignShow=true"> <i class="fa fa-search"></i></b-btn>
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        hover
        small
        style="font-size:smaller;"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
        show-empty
      >
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Revision Order</b-dropdown-item>
          <b-dropdown-item @click="rowApproval(data.item)" href="#" style="padding:0 !important;">Approval</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  style="padding:0 !important;"> Delete</b-dropdown-item>
        </b-dropdown>
      </template>        

        <template v-slot:cell(revisiondate)="data">{{ data.item.revisiondate | moment('YYYY-MM-DD')}}</template>
        <template v-slot:cell(OrderDate)="data">{{ data.item.OrderDate | moment('YYYY-MM-DD')}}</template>
        <template v-slot:cell(ExtrDocNo)="data">{{ data.item.ExtrDocNo}}
              <b-link v-if="(data.item.attchFileNm)" @click="attachmentDownload(data.item)"><i class="fa fa-paperclip"></i></b-link>
        </template>
        <template v-slot:cell(ttlratecard)="data">{{ data.item.ttlratecard | numFormat }}</template>
        <template v-slot:cell(savingvalue)="data">{{ data.item.savingvalue | numFormat }}</template>
        <template v-slot:cell(ttldiskon)="data">{{ data.item.ttldiskon | numFormat }}</template>
        <template v-slot:cell(ttlnetto)="data">{{ data.item.ttlnetto | numFormat }}</template>
        <template v-slot:cell(status)="data">
          <div v-if="data.item.send2wf==0" style="background-color:yellow;">           
            DRAFT
          </div>
          <div v-else> 
            <div v-if="data.item.iscomplete==0">           
              ON PROCESS
            </div>
            <div v-else>           
                <div v-if="data.item.issuccess==1"  style="background-color:#04f681;">           
                  APPROVED
                </div>
                <div v-else style="background-color:#f86c6b;">           
                  REJECTED
                </div>
            </div>
          </div>
        </template>

        <template v-slot:cell(empty)="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="scope">
          <h4>{{ scope.emptyFilteredText }}</h4>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to
            <span
              v-if="((tblData.page * tblData.limit)>tblData.total)"
            >{{tblData.total}}</span>
            <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label="Limit per page" class="mb-0">
          <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>  
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            v-if="pagination" 
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>

      <b-modal v-model="showApprovalConfirm" header-bg-variant="primary"  title="Approval Form" size="lg" :centered="true" hide-footer>
          <b-row>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Revision Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.revisiondate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-row>
              <b-col lg="6">
                  <b-input-group>
                      <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                      <b-form-input v-model="model.nomor" readonly></b-form-input>
                  </b-input-group>
              </b-col>
              <b-col lg="6">                            
                  <b-input-group>
                      <b-input-group-prepend><label>Order Date</label></b-input-group-prepend>
                      <b-form-input v-model="model.OrderDate" type="date"  disabled></b-form-input>                                        
                  </b-input-group>
              </b-col>
          </b-row >  
          <b-input-group >
              <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
              <b-form-input v-model="model.custinfo"  readonly></b-form-input>
              <b-input-group-prepend><span class="input-group-text">Advertiser</span></b-input-group-prepend>
              <b-form-input v-model="model.Advertiser"  readonly></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Keterangan/Judul</label></b-input-group-prepend>
              <b-form-input v-model="model.uraian"  readonly></b-form-input>
          </b-input-group>
          <div v-if="(this.model.send2wf==1)">
            <label>Workflow process history</label>
            <div class="report-wraper">
                <table width="100%">
                <thead>
                <tr>
                <th width="120px">Assign Date</th>
                <th width="220px">Assign To</th>
                <th width="80px">Action Take</th>
                <th >Comment</th>
                <th width="120px">Complete Date</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in approvalHistory" :key="row.taskassignkey">
                  <td> {{row.assignstr | moment("dddd , DD-MMM-YYYY hh:mm:ss")}} </td>
                  <td>{{row.crewnik}} | {{row.crewname}}</td>
                  <td>{{row.actiontake}} 
                      <p v-if="(row.crewname !== row.actionBy)">{{row.actionBy}}</p></td>
                  <td>{{row.message}}</td>
                  <td><span v-if="(row.completeddate)">{{row.completeddate | moment("ddd DD-MMM-YYYY hh:mm:ss")}}</span></td>
                  </tr>
                  <tr> <td colspan="5" class="subtotal"></td></tr>
                  </tbody>
                  </table>
              </div>
              <b-row class="justify-content-center mt-1" > 
                  <b-button variant="primary" @click="printApproval"><i class="fa fa-print"></i> Print Approval</b-button>
                  <b-button variant="danger" class="ml-1" v-if="((model.iscomplete==0)  || (model.isreject==1) || (approvalHistory.length==0))" @click="showApprovalCancelConfirm=true" > <i class="fa fa-undo"></i> Cancel Approval</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
          <div no-body v-else>
            <label>Add Attachment</label>
              <b-form-file
              v-model="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              ></b-form-file>
              <div class="mt-3" >Selected file: <strong>{{ file ? file.name : '' }}</strong></div>   
              <b-row class="justify-content-center mt-1" v-if="(showConfirmNoFile)">
                  <label style="width:260px !important;">Send without attachment, are you sure?</label>
                    <b-form-radio-group  v-model="confirmNoFile"  class="ml-1" >
                        <b-form-radio :value="true">Yes</b-form-radio>
                        <b-form-radio :value="false">No</b-form-radio>
                    </b-form-radio-group>
              </b-row>
              <b-row class="justify-content-center mt-1" >
                  <b-button variant="primary" @click="approval"><i class="fa fa-paper-plane"></i> Send to Workflow</b-button>
                  <b-button variant="secondary" class="ml-1" @click="showApprovalConfirm=false" > <i class="fa fa-close"></i> Close</b-button>
              </b-row>
          </div>
      </b-modal>
      <b-modal v-model="showApprovalCancelConfirm" title="Remove from workflow Approval Process?" :centered="true" @ok="approvalUndo">
        <p class="mb-1">The selected a row of data will be removed from Workflow?</p>
      </b-modal>

    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <b-modal v-model="lkuKoranCustShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-koran-cust @click="onSelectKoranCust"></lku-koran-cust>
    </b-modal>
    <b-modal v-model="lkuSalesShow" size="lg" :hide-footer="true" title="List of Sales Ex." :centered="true">
      <lku-salesae @click="onSelectsales"></lku-salesae>
    </b-modal>
    <b-modal v-model="lkuSalesCamapignShow" size="lg" :hide-footer="true" title="List of Campaign" :centered="true" >
      <lku-salescampaign @click="onSelectsalescamapign"></lku-salescampaign>
    </b-modal>

    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-so {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }
</style>


<script>
import toastr from "mini-toastr";
// import { validationMixin } from "vuelidate";
// import { required } from "vuelidate/lib/validators";
import moment from "moment";
toastr.init();

// LKU
import lkuSalescampaign from "../lookup/lkuSalesCampaign";
import lkuKoranCust from "../lookup/lkuCustomer";
import lkuSalesae from "../lookup/lkuSalesae";
// API
import task from "../../apis/task";
import salesrevorder from "../../apis/salesrevorder";

export default {
  components: { lkuSalescampaign, lkuKoranCust, lkuSalesae },
  // mixins: [validationMixin],
  // validations: {
  // },
  data() {
    return {
      showDelConfirm: false,
      showApprovalConfirm: false,
      approvalHistory:[],
      file:null,
      confirmNoFile:false,
      showConfirmNoFile:'',
      showApprovalCancelConfirm: false,

      lkuSalesCamapignShow: false,
      lkuKoranCustShow: false,
      lkuSalesShow: false,
      byae: 0,
      showFilter: false,
      showReport: false,
      reportUrl: null,
      items:[],
      limit: 15,
      pagination:true,
      model:{},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1: this.$store.state.user.tglaktif,
        tgl2: moment().format('YYYY-MM-DD'),
        sortBy: null,
        sortDesc: true,
        DimCol: "Dim1",
        outstand: "1"
      }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
        {
          key: "revisiondate",
          thStyle: "width:90px",
          label: "Revision Date",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "revisionnote",
          label: "Revision Note",
        },
        {
          key: "nomor",
          label: "Order Number",
          sortable: true
        },
        {
          key: "OrderDate",
          thStyle: "width:90px",
          label: "Order Date",
          tdClass: "text-center",
          sortable: true
        },
        {
          key: "custinfo",
          label: "Customer",
          sortable: true
        },
        {
          key: "ExtrDocNo",
          label: "Cust. PO/Doc.No",
        },
        {
          key: "brand",
          label: "Brand",
        },
        {
          key: "kategori",
          label: "Category",
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true
        },
        {
          key: "ttlratecard",
          label: "Gross (Rate Card)",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "savingvalue",
          label: "Saving Value",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "ttldiskon",
          label: "Discount",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:90px",
          sortable: true
        },
        {
          key: "ttlnetto",
          label: "Netto",
          thClass: "text-right",
          tdClass: "text-right",
          thStyle: "width:100px",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales/AE",
          thStyle: "width:90px",
          sortable: true
        },
          {
            key: "status",
            label: "Approval status",
            thStyle: "width:90px",
            sortable: true
          },
      ];
      return fields;
    },
   
    dimension() {
      return this.$store.state.dimension;
    }
  },
  watch: {
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
    dimCol: function(newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find(
        d => d.value === newval
      ).text;
    }
  },
  created: async function() {
    this.$store.commit("SoRevMenu", this.$route.name);
    if (this.$route.params.byae==1)  {
      this.tblData.createby=this.$store.state.user.username;
      this.byae=1;
    }
  },
  methods: {
    onSelectsalescamapign(_selected) {
      this.tblData.campaign = `${_selected.uraian}`;
      // this.tblData.CampaignNo = _selected.campaignKey;
      this.tblData.CampaignKey = _selected.campaignKey;
      this.lkuSalesCamapignShow = false;
    },    
    onSelectKoranCust(_selected) {
      this.tblData.customer = _selected.CustCode;
      this.lkuKoranCustShow = false;
    },
    onSelectsales(_selected) {
      this.tblData.sales_search = _selected.crewnik;
      this.lkuSalesShow = false;
    },
    attachmentDownload : async function(fl) {
        this.isLoading=true;
        try {
            await salesrevorder.attachmentDownload(fl);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            console.log('error : ', error);
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }   
        }
    },       
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.SalesorderList) {
            this.tblData[key] = filter.SalesorderList[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.SalesorderList.tgl1 || '';
          this.tblData.tgl2=filter.SalesorderList.tgl2 || '';
          this.showFilter=filtered;
          delete filter.SalesorderList;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await salesrevorder.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
            }

        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await salesrevorder.list(this.tblData);
                  this.pagination=true;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                    if (error.sql) {
                        toastr.error(error.sql,'ERROR MESSAGE',10000);
                    } else if (error.sqlMessage) {
                        toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                    } else if (error.message) {
                        toastr.error(error.message,'ERROR MESSAGE',10000);
                    } else {
                        toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                    }        
                }
        }
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.customer_id = "";
      this.tblData.Advertiser = "";
      this.tblData.campaign = "";
      this.tblData.campaignKey = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.ExtrDocNo = "";
      this.tblData.sales_search = "";
      // this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['Advertiser', 'brand', 'campaign', 'campaignKey', 'customer', 'customer_id', 'DimCol', 'DimColInfo', 'DimVal', 'ExtrDocNo', 'iscompliment', 'isdiscount', 'issavingrate', 'nomor', 'sales_search', 'tahun', 'tgl1', 'tgl2', 'status', 'uraian', 'createby'];
      let filtered = false;
      const SalesorderList={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              SalesorderList[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          SalesorderList.page=this.tblData.page;
          SalesorderList.limit=this.tblData.limit;
          SalesorderList.sortBy=this.tblData.sortBy;
          SalesorderList.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.SalesorderList=SalesorderList;
          this.$store.commit("filter", filter);
      }
    },    
    rowApproval(record) {
      this.rowClicked(record);
        this.approvalConfirm();        
    },
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.print();        
    },
    rowPrintSO(record) {
      this.rowClicked(record);
        this.printSO();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();

    },
    add: function() {
      this.saveFilter();
      router.push({ name: "sales.revisionorderfrm", params:{byae: this.byae} });
    },
    edit: function() {
      if (!this.model.revisionkey) {
            toastr.warn('Please select a row that want to be Edit!');
      } else {
          this.saveFilter();
          router.push({
            name: "sales.revisionorderfrm",
            params: { revisionkey: this.model.revisionkey, byae: this.byae }
          });
      }
    },
    deleteConfirm(item) {
      if (!this.model.revisionkey) {
            toastr.warn('Please select a row that want to be Deleted!');
      } else {
        this.showDelConfirm = true;
      }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await salesrevorder.remove(this.model);
      this.refresh();
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    async print() {
      if (!this.model.revisionkey) {
        toastr.info("Select 1 row detail first.");
      } else {
      this.reportUrl=null; this.showReport = true;

        this.reportUrl = await salesrevorder.print(this.model);

        // this.reportUrl = await salesrevorder.print(this.model);
//         if (this.$isMobile()){
//             window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
//         } else {
//           this.showReport=true;
//         }
      }
    },
    async printSO() {
      if (!this.model.salesHdrKey) {
        toastr.info("Select 1 row detail first.");
      } else {
      this.reportUrl=null; this.showReport = true;

        this.reportUrl = await salesorder.printSO(this.model);

        // this.reportUrl = await salesorder.printSO(this.model);
//         if (this.$isMobile()){
//             window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
//         } else {
//           this.showReport=true;
//         }
      }
    },

    exportxls: async function() {
      this.isLoading = true;
      try {
        await salesrevorder.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    approvalConfirm: async function () {
        if (this.model.revisionkey) {
            if (this.model.send2wf==1) {
              try {
                const data = await task.approvalhistory({key: this.model.revisionkey});
                this.approvalHistory=data;                
              } catch (error) {
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }                
              }
            }
            this.model.revisiondate = this.model.revisiondate ? moment(this.model.revisiondate).format('YYYY-MM-DD') : '';
            this.model.OrderDate = this.model.OrderDate ? moment(this.model.OrderDate).format('YYYY-MM-DD') : '';
            this.showApprovalConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be sent to workflow Approval!');
        }
    }, 
    approval: async function(evt){
        evt.preventDefault()
        try {
            const formData = new FormData();
            if (!(this.file)) {
              if (this.confirmNoFile==false){
                toastr.info('Send without attachment, are you sure?');
                this.showConfirmNoFile=true;
                return;
              }
            } else {
              formData.append('file', this.file);
              formData.append('filename', this.file.name);
            }
            formData.append('tablekey', this.model.revisionkey);
            this.showApprovalConfirm = false;
            this.isLoading=true;
            const resp = await salesrevorder.approval(formData);
            this.model.send2wf=1;
            this.refresh();
            this.isLoading=false;
            if (resp.message) {
                toastr.warn(resp.message,'warning',10000);
            }
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    approvalUndo: async function(){
        this.isLoading=true;
        try {
            await salesrevorder.approvalUndo(this.model);
            this.model.send2wf=0;
            this.showApprovalConfirm = false;
            this.refresh();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    printApproval: async function()
    {
      if (this.model.salesHdrKey) {
          this.isLoading=true;
          try {
                this.showReport=true;
              this.reportUrl= await task.approvalprint({key: this.model.salesHdrKey});
              this.isLoading=false;
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },      

    close() {
      router.push({name: "sales.home"});
    }
  }
};
</script>
